export default __webpack_public_path__ + "static/media/volume_down_black_48dp.85914d97.svg";